<template>
  <div class="company bg-weight">
    <loading v-if="busy" style="background: #fff;margin-top: 100px;"></loading>

    <div v-else>
      <div class="small-title" :class="isShowTop !== 1 ? 'small-persion-title': ''">
        <i></i>
        <span>企业展示信息</span>
      </div>
      <div>
        <div class="item" id="category">
          <div class="left">
            <span class="text">
              <span>*</span>行业类别：
            </span>
          </div>
          <div
            class="input2"
            v-if="(!realNameAuth && !detailData) || (detailData && detailData.status === 3)"
          >
            <p class="errorMsg">{{errorMsg.industryCategory}}</p>
            <Select v-model="user.industryCategory" style="width:124px;">
              <Option v-for="(item, index) in categoryData" :value="item" :key="index">{{item}}</Option>
            </Select>
          </div>
          <div v-else class="input2">{{user.industryCategory || '暂无'}}</div>
        </div>
        <div class="item">
          <div class="left">
            <span class="text">
              <span>*</span>所在地：
            </span>
          </div>
          <div
            class="input2"
            v-if="(!realNameAuth && !detailData) || (detailData && (detailData.status === 3 || !detailData.status ))"
            id="input2"
          >
            <p class="errorMsg">{{errorMsg.detailAddress}}</p>
            <div class="city" id="city" style="width: 154px;">
              <span class="label" style="margin-left:0px;">省份：</span>
              <div class="provice">
                <Select name="province" @on-change="changeProvince" v-model="provinceId">
                  <Option :value="p.id" :key="p.id" v-for="p in addressData">{{p.name}}</Option>
                </Select>
              </div>
            </div>

            <div class="city" id="city">
              <span class="label" style="margin-left:20px;">城市：</span>
              <Select name="city" @on-change="changeCity" v-model="cityId">
                <Option :value="c.id" :key="c.id" v-for="c in cityData">{{c.name}}</Option>
              </Select>
            </div>

            <div class="city" id="cityCC">
              <span class="label" style="margin-left:20px;">区/县：</span>
              <Select name="city" @on-change="changeArea" v-model="user.locationId">
                <Option :value="c.id" :key="c.id" v-for="c in areaData">{{c.name}}</Option>
              </Select>
            </div>
            <div>
                <div class="item name">
                    <div class="left"><span class="text"><span>*</span>企业名称：</span></div>
                    <div class="input1" v-if="!auth">
                        <p class="errorMsg">{{errorMsg.companyName}}</p>
                        <input @blur="checkInput('companyName', false)"  style="width: 428px;" type="text" v-model="user.companyName">
                        <i class="iconfont icon-close" v-if="user.companyName" @click="clear($event,'companyName')"></i>
                    </div>
                    <div class="input1" v-else>
                        {{user.companyName || '暂无'}}
                    </div>
                </div>
                <div class="item name">
                    <div class="left"><span class="text"><span>*</span>营业执照注册号：</span></div>
                    <div class="input1" v-if="!auth">
                        <p class="errorMsg">{{errorMsg.businessLicenceId}}</p>
                        <input @blur="checkInput('businessLicenceId', false)" style="width: 428px;" v-model="user.businessLicenceId">
                        <i class="iconfont icon-close" v-if="user.businessLicenceId" @click="clear($event,'businessLicenceId')"></i>
                    </div>
                    <div class="input1" v-else>
                        {{user.businessLicenceId || '暂无'}}
                    </div>
                </div>
                <div class="item name">
                    <div class="left"><span class="text"><span>*</span>法人姓名：</span></div>
                    <div class="input1" v-if="!auth">
                        <p class="errorMsg">{{errorMsg.legalPerson}}</p>
                        <input @blur="checkInput('legalPerson', false)" style="width: 148px;" type="text" v-model="user.legalPerson">
                        <i class="iconfont icon-close" v-if="user.legalPerson" @click="clear($event,'legalPerson')"></i>
                    </div>
                    <div class="input1" v-else>
                        {{user.legalPerson || '暂无'}}
                    </div>
                </div>
                <div class="item name">
                    <div class="left"><span class="text"><span>*</span>法人身份证号：</span></div>
                    <div class="input1" v-if="!auth">
                        <p class="errorMsg">{{errorMsg.legalPersonIdentityCard}}</p>
                        <input @input="changeIdcard(user.legalPersonIdentityCard)" @blur="checkInput('legalPersonIdentityCard', false)" style="width: 428px;" type="text" v-model="user.legalPersonIdentityCard">
                        <i class="iconfont icon-close" v-if="user.legalPersonIdentityCard" @click="clear($event,'legalPersonIdentityCard')"></i>
                    </div>
                    <div class="input1" v-else>
                        {{user.legalPersonIdentityCard || '暂无'}}
                    </div>
                </div>
                <div class="item name">
                    <div class="left"><span class="text"><span>*</span>法人手机号：</span></div>
                    <div class="input1" v-if="!auth">
                        <p class="errorMsg">{{errorMsg.legalPersonMobilePhone}}</p>
                        <input @blur="checkInput('legalPersonMobilePhone', false)" style="width: 148px;" type="number" v-model="user.legalPersonMobilePhone">
                        <i class="iconfont icon-close" v-if="user.legalPersonMobilePhone" @click="clear($event,'legalPersonMobilePhone')"></i>
                    </div>
                    <div class="input1" v-else>
                        {{user.legalPersonMobilePhone || '暂无'}}
                    </div>
                </div>
            </div>
            <div class="code">
              <div class="input1">
                <p class="errorMsg">{{errorMsg.code}}</p>
                <input
                  @blur="checkInput('code', false)"
                  type="number"
                  v-model="user.code"
                  placeholder="请输入验证码"
                >
                <span class="disableSpan" v-if="timer > 0">{{timer}}s后发送</span>
                <span v-else @click="getCode">点击发送</span>
              </div>
            </div>
          </div>
          <div v-else class="input1">{{user.proposerPhone || '暂无'}}</div>
        </div>
      </div>
      <div class="small-title" :class="isShowTop !== 1 ? 'small-persion-title': ''">
        <i></i>
        <span>企业资料上传</span>
      </div>
      <div>
        <div class="item" :id="isShowTop !== 1 ? 'item3-small' : 'item3'">
          <div class="left">
            <span class="text">
              <span>*</span>
              <span>企业</span>工商营业执照：
            </span>
          </div>
          <div
            class="input5"
            v-if="(!realNameAuth && !detailData) || (detailData && (detailData.status === 3 || !detailData.status))"
          >
            <div class="left" :class="isShowTop !== 1 ? 'left-small' : ''">
              <my-upload
                :type="17"
                style="height: 100%;"
                :format="['jpg','jpeg','png']"
                @success="handleSuccess1"
                @uploadError="handleUploadError"
                @formatError="handleFormatError"
                @progress="handleProgress1"
              >
                <div slot="style">
                  <div
                    class="preview"
                    :class="isShowTop !== 1 ? 'preview-small': ''"
                    v-if="businessLicenceFile.key && !upload.certificateFile1 && !isLoading1"
                  >
                    <img :src="imgBaseUrl+businessLicenceFile.key">
                  </div>
                  <div
                    class="preview"
                    :class="isShowTop !== 1 ? 'preview-small': ''"
                    v-if="progress1 === 0 && upload.certificateFile1"
                  >
                    <img
                      v-if="upload.certificateFile1"
                      :src="imgBaseUrl+upload.certificateFile1.key"
                    >
                  </div>
                  <span
                    v-if="progress1 === 0 && !upload.certificateFile1 && !businessLicenceFile.key"
                  >
                    <i class="iconfont icon-camera"></i>
                    <p>点击上传</p>
                  </span>
                  <span class="loading" v-if="progress1 > 0 && progress1 < 100 ">
                    <i-circle
                      :percent="progress1"
                      :size="50"
                      trail-color="#EBEFF0"
                      :trail-width="4"
                      :stroke-width="4"
                      stroke-color="#3DBD7D"
                    >
                      <i class="iconfont" style="font-size: 15px;margin-top: 0px;">{{progress1}}%</i>
                    </i-circle>
                  </span>
                </div>
              </my-upload>
            </div>
            <div class="right exImg" :class="isShowTop !== 1 ? 'right-small': ''">
              <img src="../../../images/user/business_licence.jpg" @click="showImg(imgData01)" alt>
              <span>例：</span>
            </div>
          </div>
          <div class="input5" v-else>
            <div class="left specail-left" :class="isShowTop !== 1 ? 'left-small' : ''">
              <div slot="style">
                <div
                  class="preview"
                  :class="isShowTop !== 1 ? 'preview-small': ''"
                  v-if="businessLicenceFile && businessLicenceFile.key && !upload.certificateFile1 && !isLoading1"
                >
                  <img :src="imgBaseUrl+businessLicenceFile.key">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item" :id="isShowTop !== 1 ? 'item4-small' : 'item4'">
          <div class="left">
            <span class="text">
              <span>*</span>企业认证委托授权书：
            </span>
          </div>
          <div
            class="input5"
            v-if="(!realNameAuth && !detailData) || (detailData && (detailData.status === 3 || !detailData.status))"
          >
            <div class="left" :class="isShowTop !== 1 ? 'left-small' : ''">
              <my-upload
                :type="17"
                style="height: 100%;"
                :format="['jpg','jpeg','png']"
                @success="handleSuccess2"
                @uploadError="handleUploadError"
                @formatError="handleFormatError"
                @progress="handleProgress2"
              >
                <div slot="style">
                  <div
                    class="preview"
                    :class="isShowTop !== 1 ? 'preview-small': ''"
                    v-if="evidenceMaterialFile.key && !upload.certificateFile2 && !isLoading2"
                  >
                    <img :src="imgBaseUrl+evidenceMaterialFile.key">
                  </div>
                  <div
                    class="preview"
                    :class="isShowTop !== 1 ? 'preview-small': ''"
                    v-if="progress2 === 0 && upload.certificateFile2"
                  >
                    <img
                      v-if="upload.certificateFile2"
                      :src="imgBaseUrl+upload.certificateFile2.key"
                    >
                  </div>
                  <span
                    v-if="progress2 === 0 && !upload.certificateFile2 && !evidenceMaterialFile.key"
                  >
                    <i class="iconfont icon-camera"></i>
                    <p>点击上传</p>
                  </span>
                  <span class="loading" v-if="progress2 > 0 && progress2 < 100 ">
                    <i-circle
                      :percent="progress2"
                      :size="50"
                      trail-color="#EBEFF0"
                      :trail-width="4"
                      :stroke-width="4"
                      stroke-color="#3DBD7D"
                    >
                      <i class="iconfont" style="font-size: 15px;margin-top: 0px;">{{progress2}}%</i>
                    </i-circle>
                  </span>
                </div>
              </my-upload>
            </div>
            <div class="right exImg pecail-exImg" :class="isShowTop !== 1 ? 'right-small': ''">
              <div class="img-con">
                <img src="../../../images/user/entrustment1.png" alt @click="showImg(imgData02)">
                <span class="clickDown">
                  <i class="iconfont icon-template"></i>
                  <span>
                    <a
                      target="_blank"
                      href="http://oss.51xuewudao.cn/basedata/%E4%BC%81%E4%B8%9A%E8%AE%A4%E8%AF%81%E5%A7%94%E6%89%98%E6%8E%88%E6%9D%83%E4%B9%A6.docx"
                    >下载委托书模版</a>
                  </span>
                </span>
              </div>
              <span>例：</span>
            </div>
          </div>
          <div class="input5" v-else>
            <div class="left specail-left" :class="isShowTop !== 1 ? 'left-small' : ''">
              <div slot="style">
                <div
                  class="preview"
                  :class="isShowTop !== 1 ? 'preview-small': ''"
                  v-if="evidenceMaterialFile && evidenceMaterialFile.key && !upload.certificateFile2 && !isLoading2"
                >
                  <img :src="imgBaseUrl+evidenceMaterialFile.key">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sure" @click="sureText" v-if="!realNameAuth || !auth">
        <span :class="suerTextData ? 'checkboxed' : 'check-box'"></span>
        <span class="text">我保证作品的原创性，上传的图片没有法律纠纷，我对因虚假资料或图片版权引起的法律纠纷负全部责任。</span>
      </div>
      <div class="sure" @click="sureText" v-if="realNameAuth && auth">
        <span class="checkboxed"></span>
        <span class="text">我保证作品的原创性，上传的图片没有法律纠纷，我对因虚假资料或图片版权引起的法律纠纷负全部责任。</span>
      </div>

      <div v-if="!detailData">
        <div class="button">
          <button :disabled="buttonBusy" @click="submitButton">立即提交</button>
        </div>
      </div>
      <div v-else>
        <div class="button" v-if="detailData && detailData.status === 1">
          <span class="specail">正在审核中...</span>
        </div>
        <div
          class="button"
          v-if="detailData && detailData.status === 2 && userInfo.certification > 0"
        >
          <span class="specail-green">认证通过</span>
        </div>
        <div
          class="button"
          v-if="detailData && detailData.status === 2 && userInfo.certification === 0"
        >
          <button :disabled="buttonBusy" @click="submitButton">确认修改</button>
        </div>
        <div class="button" v-if="(detailData && detailData.status === 3) || !detailData.status">
          <button :disabled="buttonBusy" @click="submitButton">确认修改</button>
        </div>
      </div>
      <dialog-box ref="dialog"></dialog-box>
      <Modal v-model="imgValidator" class="imgValidator" width="360">
        <div class="close-btn" slot="close">
          <i class="iconfont icon-pop-close"></i>
        </div>
        <div slot="header" class="title">请输入验证码</div>
        <img-validate ref="imgValidator" :phone="user.proposerPhone" @sendMsg="sendMsgBegin"></img-validate>
      </Modal>
      <image-view ref="imgView"></image-view>
      <delete-confirm ref="deleteConfirm"></delete-confirm>
    </div>
  </div>
</template>
<script>
import api from "../../../api";
import util from "../../../libs/util";
import myUpload from "../../common/myUpload.vue";
import validator from "../account/validator";
import loading from "../../common/loading.vue";
import store from "../../../store";
const reg_phone = validator.reg_phone;
import dialogBox from "./dialog.vue";
import deleteConfirm from "../../common/deleteConfirm.vue";
import imgValidate from "../account/imgValidateModal.vue";
import imageView from "../order/detail/imageView.vue";
import img01 from "../../../images/user/business_licence.jpg";
import img02 from "../../../images/user/entrustment.jpg";
export default {
  data() {
    return {
      user: {
        companyName: "",
        businessLicenceId: "",
        legalPerson: "",
        legalPersonIdentityCard: "",
        legalPersonMobilePhone: "",
        proposerName: "",
        proposerPhone: "",
        code: "",
        industryCategory: "",
        locationId: null
      },
      errorMsg: {
        companyName: "",
        businessLicenceId: "",
        legalPerson: "",
        legalPersonIdentityCard: "",
        legalPersonMobilePhone: "",
        proposerName: "",
        proposerPhone: "",
        code: "",
        industryCategory: "",
        detailAddress: "",
        detailAddressData: ""
      },
      suerTextData: false,
      provinceId: "",
      addressData: [],
      cityData: [],
      areaData: [],
      imgBaseUrl: api.common.imgBaseUrl,
      upload: {
        certificateFile1: null,
        certificateFile2: null
      },
      isUploadUse: {
        idCard: 0,
        works: 0
      },

      businessLicenceFile: {
        id: 0,
        key: null
      },
      evidenceMaterialFile: {
        id: 0,
        key: null
      },

      isLoading1: false,
      isLoading2: false,
      proviceText: "",
      cityText: "",
      areaText: "",
      imgValidator: false,
      hasSendMsg: false,
      timer: 0,
      cityId: null,
      categoryData: null,
      progress1: 0,
      progress2: 0,
      imgData01: img01,
      imgData02: img02,
      detailData: null,
      busy: false,
      auth: false,
      realNameAuth: false,
      buttonBusy: false
    };
  },
  props: {
    isShowTop: {
      type: Number,
      default: 1
    }
  },
  components: {
    myUpload,
    dialogBox,
    imgValidate,
    imageView,
    deleteConfirm,
    loading
  },
  computed: {
    userInfo() {
      return this.$store.state.user.info;
    }
  },
  methods: {
    changeIdcard(val) {
      const reg = /^[^\u4e00-\u9fa5]+$/;
      if (!reg.test(val)) {
        this.user.legalPersonIdentityCard = "";
      }
    },
    showImg(src) {
      this.$refs.imgView.open(src);
    },
    industry_category() {
      api.account.industry_category().then(res => {
        this.categoryData = res;
      });
    },
    getCode() {
      if (this.user.proposerPhone) {
        if (!reg_phone.test(this.user.proposerPhone)) {
          this.errorMsg.proposerPhone = "您输入的手机号不符合规则";
          return;
        } else {
          api.account
            .checkPhoneExist({
              phone: this.user.proposerPhone
            })
            .then(res => {
              if (res) {
                this.$refs.imgValidator.open("phone");
                this.imgValidator = true;
              }
            });
        }
      } else {
        this.errorMsg.proposerPhone = "手机号必填";
      }
    },
    sendMsgBegin() {
      this.closeImgValidator();
      let that = this;
      this.timer = parseInt(util.getCookie("authenticationCountDown")) || 90;
      that.timerInterval = setInterval(function() {
        that.timer--;
        util.setCookie("authenticationCountDown", that.timer);
        if (that.timer == 0) {
          util.setCookie("authenticationCountDown", "", -1);
          clearInterval(that.timerInterval);
        }
      }, 1000);
    },
    closeImgValidator() {
      this.imgValidator = false;
    },
    handleSuccess1(data) {
      this.upload.certificateFile1 = data.data[0];
      this.businessLicenceFile.id = data.data[0].id;
      this.progress1 = 0;
    },
    handleSuccess2(data) {
      this.upload.certificateFile2 = data.data[0];
      this.evidenceMaterialFile.id = data.data[0].id;
      this.progress2 = 0;
    },
    handleUploadError() {
      this.$Message.error("上传失败,请重新上传");
    },
    handleFormatError() {
      this.$Message.error("请选择 jpg,jpeg 或 png 格式的文件");
    },
    handleProgress1(progress) {
      if (progress) {
        this.isLoading1 = true;
        this.progress1 = progress;
      }
    },
    handleProgress2(progress) {
      if (progress) {
        this.isLoading2 = true;
        this.progress2 = progress;
      }
    },
    initLocation() {
      if (!this.user.locationId) {
        return;
      }
      this.addressData.forEach(province => {
        province.cities.forEach(city => {
          this.cityData = city.cities;
          this.cityId = city.id;
          this.cityData.forEach(cityCC => {
            if (cityCC.id === this.user.locationId) {
              this.provinceId = province.id;
              this.areaData = cityCC.cities;
              this.proviceText = province.name;
              this.cityText = city.name;
              this.areaText = cityCC.name;
            }
          });
        });
      });
    },
    changeProvince(pid) {
      this.errorMsg.detailAddress = "";
      this.addressData.forEach(province => {
        if (province.id == pid) {
          this.cityData = province.cities;
          this.proviceText = province.name;
          this.cityId = null;
          this.user.locationId = null;
        }
      });
    },
    changeCity(cid) {
      this.errorMsg.detailAddress = "";
      this.cityData.forEach(city => {
        if (city.id === cid) {
          this.cityText = city.name;
          this.areaData = city.cities;
          this.user.locationId = null;
        }
      });
    },
    changeArea(aid) {
      this.errorMsg.detailAddress = "";
      this.areaData.forEach(area => {
        if (area.id === aid) {
          // this.provinceId = area.id;
          this.areaText = area.name;
        }
      });
    },
    clear(e, key) {
      e.target.previousElementSibling.focus();
      this.user[key] = "";
    },
    sureText() {
      this.suerTextData = !this.suerTextData;
    },

    submitButton() {
      if (this.validate("nothing", true)) {
        if (this.suerTextData) {
          this.buttonBusy = true;
          let data = {
            businessLicenceFile: this.businessLicenceFile,
            evidenceMaterialFile: this.evidenceMaterialFile,
            companyName: this.user.companyName,
            businessLicenceId: this.user.businessLicenceId,
            legalPerson: this.user.legalPerson,
            legalPersonIdentityCard: this.user.legalPersonIdentityCard,
            legalPersonMobilePhone: this.user.legalPersonMobilePhone,
            proposerName: this.user.proposerName,
            proposerPhone: this.user.proposerPhone,
            code: this.user.code,
            industryCategory: this.user.industryCategory,
            locationId: this.user.locationId
          };
          api.account
            .verifyCompany(data)
            .then(res => {
              if (res.realNameAuth) {
                this.$router.push({ name: "myApplicationing" });
              } else {
                this.$Message.error("实名认证审核失败！");
              }
              this.buttonBusy = false;
            })
            .catch(err => {
              this.$refs.deleteConfirm.open({
                text: err.data.message || "服务器出错！",
                bigButton: true
              });
              this.buttonBusy = false;
            });
        } else {
          this.$Message.error("请确定相关责任！");
        }
      }
    },
    getVerifyCompany() {
      this.busy = true;
      api.account.getVerifyCompany().then(res => {
        if (res) {
          this.auth = res.realNameAuth;
          this.realNameAuth = res.auth;
          if (this.auth) {
            this.$emit("isShowCheck", 1);
          }
          if (res.obj) {
            if (res.obj.companyName) {
              this.detailData = res.obj;
              if (res.obj.businessLicenceFile) {
                this.businessLicenceFile = res.obj.businessLicenceFile;
              } else {
                this.businessLicenceFile = { id: 0, key: null };
              }
              if (res.obj.evidenceMaterialFile) {
                this.evidenceMaterialFile = res.obj.evidenceMaterialFile;
              } else {
                this.evidenceMaterialFile = { id: 0, key: null };
              }
              this.user.companyName = res.obj.companyName;
              this.user.proposerPhone = res.obj.proposerPhone;
              this.user.businessLicenceId = res.obj.businessLicenceId;
              this.user.legalPerson = res.obj.legalPerson;
              this.user.legalPersonIdentityCard =
                res.obj.legalPersonIdentityCard;
              this.user.legalPersonMobilePhone = res.obj.legalPersonMobilePhone;
              this.user.proposerName = res.obj.proposerName;
              this.user.code = res.obj.code;
              this.user.industryCategory = res.obj.industryCategory;
              this.user.locationId = res.obj.locationId;
            }
          }
        }
        this.busy = false;
      });
    },

    checkInput(check) {
      this.validate(check, false);
    },

    validate(check, nomal) {
      if (!this.user.industryCategory) {
        this.errorMsg.industryCategory = "请选择行业类别";
        if (nomal) {
          this.$Message.error("请选择行业类别");
          return false;
        }
      } else {
        this.errorMsg.industryCategory = "";
      }

      if (!this.provinceId) {
        this.errorMsg.detailAddress = "请选择您的省份";
        if (nomal) {
          this.$Message.error("请选择您的省份");
          return false;
        }
      } else if (!this.user.locationId) {
        this.errorMsg.detailAddress = "请选择您所在城市或区/县城";
        if (nomal) {
          this.$Message.error("请选择您所在城市或区/县城");
          return false;
        }
      } else {
        this.errorMsg.detailAddress = "";
      }
      if (check === "companyName" || nomal) {
        if (!this.user.companyName) {
          this.errorMsg.companyName = "请输入企业名称";
          if (nomal) {
            this.$Message.error("请输入企业名称");
          }
          return false;
        } else {
          this.errorMsg.companyName = "";
        }
      }

      if (check === "businessLicenceId" || nomal) {
        if (!this.user.businessLicenceId) {
          this.errorMsg.businessLicenceId = "请输入营业执照注册号";
          if (nomal) {
            this.$Message.error("请输入营业执照注册号");
          }
          return false;
        } else {
          this.errorMsg.businessLicenceId = "";
        }
      }

      if (check === "legalPerson" || nomal) {
        if (!this.user.legalPerson) {
          this.errorMsg.legalPerson = "请输入法人姓名";
          if (nomal) {
            this.$Message.error("请输入法人姓名");
          }
          return false;
        } else {
          this.errorMsg.legalPerson = "";
        }
      }

      if (check === "legalPersonIdentityCard" || nomal) {
        if (!this.user.legalPersonIdentityCard) {
          this.errorMsg.legalPersonIdentityCard = "请输入法人的身份证账号";
          if (nomal) {
            this.$Message.error("请输入法人的身份证账号");
          }
          return false;
        } else if (!validator.checkCard(this.user.legalPersonIdentityCard)) {
          this.errorMsg.legalPersonIdentityCard = "法人的身份证账号不合法";
          if (nomal) {
            this.$Message.error("法人的身份证账号不合法");
          }
          return false;
        } else {
          this.errorMsg.legalPersonIdentityCard = "";
        }
      }

      if (check === "legalPersonMobilePhone" || nomal) {
        if (!this.user.legalPersonMobilePhone) {
          this.errorMsg.legalPersonMobilePhone = "请输入法人的手机号码";
          if (nomal) {
            this.$Message.error("请输入法人的手机号码");
          }
          return false;
        } else if (!reg_phone.test(this.user.legalPersonMobilePhone)) {
          this.errorMsg.legalPersonMobilePhone = "法人的手机号码不合法";
          if (nomal) {
            this.$Message.error("法人的手机号码不合法");
          }
          return false;
        } else {
          this.errorMsg.legalPersonMobilePhone = "";
        }
      }

      if (check === "proposerName" || nomal) {
        if (!this.user.proposerName) {
          this.errorMsg.proposerName = "请输入运营者姓名 ";
          if (nomal) {
            this.$Message.error("请输入运营者姓名");
          }
          return false;
        } else {
          this.errorMsg.proposerName = "";
        }
      }

      if (check === "proposerPhone" || nomal) {
        if (!this.user.proposerPhone) {
          this.errorMsg.proposerPhone = "请输入运营者手机号";
          if (nomal) {
            this.$Message.error("请输入运营者手机号");
          }
          return false;
        } else if (!reg_phone.test(this.user.proposerPhone)) {
          if (nomal) {
            this.errorMsg.proposerPhone = "您的手机号码不合法";
          }
          this.$Message.error("您的手机号码不合法");
          return false;
        } else {
          this.errorMsg.proposerPhone = "";
        }
      }

      if (check === "code" || nomal) {
        if (!this.user.code) {
          this.errorMsg.code = "请输入验证码 ";
          if (nomal) {
            this.$Message.error("请输入验证码");
          }
          return false;
        } else {
          this.errorMsg.code = "";
        }
      }
      if (nomal) {
        if (this.businessLicenceFile.id === 0) {
          this.$Message.error("请上传企业工商营业执照！");
          return false;
        }
        if (this.evidenceMaterialFile.id === 0) {
          this.$Message.error("请上传企业认证委托授权书！");
          return false;
        }
      }
      return true;
    }
  },
  created() {
    const address_name = "vuejs__ZHULOGIC_ADDRESS" || "ZHULOGIC_ADDRESS";
    let lists = JSON.parse(localStorage.getItem(address_name)).value;
    if (lists) {
      this.addressData = lists;
    } else {
      api.address.getData().then(res => {
        this.addressData = res;
        this.initLocation();
      });
    }
    this.getVerifyCompany();
      this.industry_category();
      if (util.getCookie("authenticationCountDown")) {
        this.sendMsgBegin();
      }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.small-title {
  margin-top: 60px;
  span {
    font-size: 18px;
    color: #555555;
    vertical-align: middle;
  }
  i {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #353838;
    border-radius: 50%;
    vertical-align: middle;
  }
}
.small-persion-title {
  text-align: left;
}
.main {
  width: 100%;
  /*padding: 36px 60px;*/
  #category {
    .ivu-select .ivu-select-selection {
      border: none;
      background: #ebeff0;
    }
  }

  #item2,
  #item3,
  #item4,
  #item5 {
    .ivu-upload-select {
      width: 360px;
      height: 250px;
    }
  }
  #item2-small,
  #item3-small,
  #item4-small,
  #item5-small {
    .ivu-upload-select {
      width: 320px;
      height: 222px;
    }
  }
  .item {
    margin-top: 40px;
    text-align: left;
    .left {
      display: inline-block;
      width: 150px;
      vertical-align: middle;
      .text {
        float: right;
        margin-right: 10px;
        > span {
          color: #e14b5d;
        }
      }
    }
    .input1 {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      .errorMsg {
        position: absolute;
        font-size: 12px;
        color: #e14b5d;
        left: 0px;
        top: -20px;
      }
      > i {
        position: absolute;
        right: 5px;
        top: 7px;
        font-size: 12px;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.65);
      }
      input {
        width: 148px;
        background: #ebeff0;
        border-radius: 4px;
        height: 30px;
        padding: 3px 15px;
      }
    }
    .code {
      display: inline-block;
      vertical-align: middle;
      margin-left: 25px;
      .input1 {
        input {
          width: 112px;
        }
        > span {
          display: inline-block;
          vertical-align: middle;
          padding: 6px 15px;
          background: #308697;
          border-radius: 4px;
          font-size: 12px;
          color: #ffffff;
          margin-left: 9px;
          cursor: pointer;
        }
        .disableSpan {
          background: #999;
          cursor: default;
        }
      }
    }
    .errorAddressMsg {
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
      color: #e14b5d;
    }
    .addressMsg {
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
      > input {
        width: 500px;
      }
    }
    .input2 {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      .errorMsg {
        position: absolute;
        font-size: 12px;
        color: #e14b5d;
        left: 0px;
        top: -20px;
      }
      .provice {
        display: inline-block;
        width: 90px;
        height: 28px;
        vertical-align: middle;
      }
      #city {
        display: inline-block;
        vertical-align: middle;
        width: 170px;
        height: 28px;
        > span {
          font-size: 12px;
          float: left;
          color: #555555;
          margin-left: 36px;
          vertical-align: middle;
          margin-right: 20px;
          margin-top: 6px;
        }
        .ivu-select {
          float: left;
          width: 90px;
          vertical-align: middle;
          border: none;
          ackground: #ebeff0;
        }
      }
      #cityCC {
        display: inline-block;
        vertical-align: middle;
        width: 200px;
        height: 28px;
        > span {
          font-size: 12px;
          float: left;
          color: #555555;
          margin-left: 36px;
          vertical-align: middle;
          margin-right: 20px;
          margin-top: 6px;
        }
        .ivu-select {
          float: left;
          width: 90px;
          vertical-align: middle;
          border: none;
          ackground: #ebeff0;
        }
      }
    }
    #input2 {
      .ivu-select-selected-value,
      .ivu-select-placeholder {
        background: #ebeff0;
        border: none;
      }
      .ivu-select-selection {
        background: #ebeff0;
        border: none;
      }
      .page .ivu-select .ivu-select-selection {
        border: none;
        border-radius: 4px;
      }
    }
    .input3 {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      .errorMsg {
        position: absolute;
        font-size: 12px;
        color: #e14b5d;
        left: 0px;
        top: -20px;
      }
      > i {
        position: absolute;
        right: 5px;
        top: 7px;
        font-size: 12px;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.65);
      }
      input {
        width: 420px;
        background: #ebeff0;
        border-radius: 4px;
        height: 30px;
        padding: 3px 15px;
      }
    }
    .detailAddressCC {
      vertical-align: top;
      textarea {
        width: 420px;
        background: #ebeff0;
        border-radius: 4px;
        height: 64px;
        padding: 3px 15px;
        vertical-align: top;
        border: none;
      }
    }
    .input4,
    .input5 {
      display: inline-block;
      vertical-align: top;
      .left,
      .right {
        cursor: pointer;
        display: inline-block;
        vertical-align: top;
        width: 360px;
        text-align: center;
        height: 250px;
        /*line-height: 250px;*/
        background: #ebeff0;
        border: 2px dashed #c8cccc;
        border-radius: 4px;
        margin-bottom: 20px;
        .preview {
          width: 356px;
          height: 246px;
          overflow: hidden;
          text-align: center;
          img {
            display: inline-block;
            height: 100%;
          }
        }
        .preview-small {
          width: 320px;
          height: 218px;
        }
        .loading {
          display: inline-block;
          height: 50px;
          width: 50px;
          margin-top: 100px;
        }
        i {
          display: inline-block;
          margin-top: 70px;
          font-size: 38px;
          color: #a2a2a8;
        }
        p {
          text-align: center;
          font-size: 14px;
          color: #6c6f70;
          margin-top: 9px;
        }
      }
      .left-small,
      .right-small {
        width: 320px;
        height: 222px;
      }
      .specail-left {
        border: none;
        .preview {
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .right {
        margin-left: 40px;
      }
      .exImg {
        border: none;
        background: #fff;
        > span {
          font-size: 12px;
          color: #555555;
          position: absolute;
          left: 0px;
          top: 0px;
        }
        img {
          display: inline-block;
          height: 100%;
          margin-left: 30px;
        }
      }
      .pecail-exImg {
        .img-con {
          float: left;
          width: 343px;
          height: 250px;
          background: #f2f4f5;
          border-radius: 4px;
          padding: 10px;
          position: relative;
          text-align: left;
          margin-left: 30px;
          img {
            margin-left: 7px;
          }
          .clickDown {
            > span {
              font-size: 14px;
              color: #353838;
              text-decoration: underline;
              &:hover {
                color: #e14b5d;
              }
            }
            i {
              font-size: 16px;
              vertical-align: middle;
              margin-right: 1px;
              margin-top: -6px;
              margin-left: 20px;
              color: #353838;
            }
          }
        }
      }
    }
    .input5 {
      display: inline-block;
      width: 765px;
      .left,
      .right {
        position: relative;
        .titleDesc {
          position: absolute;
          font-size: 14px;
          color: #353838;
          top: 20px;
          left: 20px;
        }
      }
    }
  }
  .sure {
    /*width: 100%;*/
    margin-top: 20px;
    float: left;
    cursor: pointer;
    margin-left: 150px;
    .check-box {
      display: inline-block;
      width: 12px;
      height: 12px;
      border: 1px solid #6c6f70;
      border-radius: 2px;
      vertical-align: middle;
      /*margin-left: 153px;*/
    }
    .checkbox {
      display: inline-block;
      width: 12px;
      height: 12px;
      border: 1px solid #c8cccc;
      border-radius: 2px;
      vertical-align: middle;
      /*margin-left: 153px;*/
    }
    .checkboxed {
      display: inline-block;
      width: 12px;
      height: 12px;
      background: #308697;
      border-radius: 2px;
      vertical-align: middle;
      /*margin-left: 153px;*/
    }
    .text {
      display: inline-block;
      vertical-align: middle;
      margin-left: 3px;
      font-size: 14px;
      color: #6c6f70;
    }
  }
  .button {
    width: 100%;
    margin-top: 118px;
    margin-bottom: 120px;
    text-align: center;
    > span {
      display: inline-block;
      background: #e14b5d;
      font-size: 14px;
      color: #ffffff;
      border-radius: 4px;
      padding: 10px 44px;
      cursor: pointer;
    }
    > button {
      display: inline-block;
      background: #e14b5d;
      font-size: 14px;
      color: #ffffff;
      border-radius: 4px;
      padding: 10px 44px;
      cursor: pointer;
    }
    > button:disabled {
      background: #6c6f70;
    }
    .specail {
      background: #929292;
      cursor: default;
    }
    .specail-green {
      background: #99c72c;
      cursor: default;
    }
  }
  .explain {
    text-align: left;
    margin-left: 102px;
    margin-top: 40px;
    padding-right: 95px;
    font-size: 12px;
    color: #555555;
    margin-bottom: -30px;

    p {
      color: #e14b5d;
    }
  }
}
</style>